module.exports = __webpack_public_path__ + "static/media/home-female.08556d99.svg";